module.exports = __webpack_public_path__ + "assets/media/quests-complete.ad682ba4.svg";